<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/finance.svg" />
          </div>
          <div>
            <div class="card_title_1">ASSET EVALUATION</div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
        <div>
          <span class="card_title_2">Periode {{ periode }}</span>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-6 tooltip-container">
          <div class="tooltip-content" v-if="visible && uidTool !== ''">
            {{ uidTool !== "" ? uidTool : "" }}
          </div>
          <select
            @mouseenter="showTooltip"
            @mouseleave="hideTooltip"
            v-model="uuid"
            class="custom-dropdown form-select"
          >
            <option
              v-for="(option, key) in dataUuid"
              :key="key"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
        <!-- <div class="col-4 tooltip-container">
          <div class="tooltip-content" v-if="visibleUpUl && upUlTool !== ''">
            {{ upUlTool !== "" ? upUlTool : "" }}
          </div>
          <select
            @mouseenter="showTooltipUpUl"
            @mouseleave="hideTooltipUpUl"
            :disabled="isUpUl"
            v-model="upul"
            class="custom-dropdown form-select"
          >
            <option
              v-for="(option, key) in dataUpul"
              :key="key"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div> -->
        <div class="col-6">
          <select v-model="unit" class="custom-dropdown form-select">
            <option
              v-for="(option, key) in dataUnit"
              :key="key"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="table-responsive"
        style="
          border: 1px solid #e5e7ed;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          margin-top: 20px;
        "
      >
        <table class="table">
          <thead
            style="
              font-size: 12px;
              font-weight: 400;
              line-height: 14.06px;
              letter-spacing: 0.02em;
            "
          >
            <tr style="--bs-table-bg: #f0f0f0">
              <th
                style="align-content: center; border-right: 1px solid white"
                @click="sort('name')"
                width="40%"
                scope="col"
                rowspan="2"
              >
                Asset<i v-if="!isAsset" class="fa fa-arrow-up"></i
                ><i v-if="isAsset" class="fa fa-arrow-down"></i>
              </th>
              <th
                scope="col"
                colspan="2"
                style="text-align: center; border-bottom: 1px solid white"
              >
                Maintenance Needed
              </th>
            </tr>
            <tr style="--bs-table-bg: #f0f0f0">
              <th
                @click="sort('old')"
                width="30%"
                scope="col"
                style="text-align: center; border-right: 1px solid white"
              >
                Old Assets <i v-if="isOld" class="fa fa-arrow-up"></i
                ><i v-if="!isOld" class="fa fa-arrow-down"></i>
              </th>
              <th
                @click="sort('broken')"
                width="30%"
                scope="col"
                style="text-align: center"
              >
                Attention Needed <i v-if="isBroke" class="fa fa-arrow-up"></i
                ><i v-if="!isBroke" class="fa fa-arrow-down"></i>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div
        class="table-responsive"
        style="height: 610px; overflow-y: scroll; border: 1px solid #e5e7ed"
      >
        <table class="table">
          <tbody
            style="
              font-size: 14px;
              font-weight: 400;
              line-height: 16.41px;
              letter-spacing: 0.02em;
            "
          >
            <tr
              v-for="(asset, key) of assetEvaluation"
              :key="key"
              :class="
                key >= Object.keys(assetEvaluation).length > 0 ? 'hidden' : ''
              "
            >
              <td width="40%">{{ asset.name }}</td>
              <td width="30%" style="text-align: center">
                {{ formattedNumber(asset.old) }}
              </td>
              <td width="30%" style="text-align: center">
                {{ formattedNumber(asset.broken) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table-responsive"
        style="
          border: 1px solid #e5e7ed;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <table style="--bs-table-bg: #f0f0f0" class="table">
          <thead
            style="
              font-size: 14px;
              font-weight: bold;
              line-height: 16.41px;
              letter-spacing: 0.02em;
            "
          >
            <tr>
              <th style="font-weight: bold" width="40%">
                {{ this.rowTotal.name }}
              </th>
              <th width="30%" style="font-weight: bold; text-align: center">
                {{ formattedNumber(this.rowTotal.old) }}
              </th>
              <th width="30%" style="font-weight: bold; text-align: center">
                {{ formattedNumber(this.rowTotal.broken) }}
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import DistributionService from "@/services/distribution/distribution";
import ReferenceService from "@/services/reference/reference";
import { formattedNumber } from "@/utils/helper";

const apiDistribution = DistributionService.build();
const getRef = ReferenceService.build();

export default {
  props: [],
  data() {
    return {
      periode: "",
      last_update: "",
      visibleUpUl: false,
      upUlTool: "",
      uidTool: "",
      visible: false,
      assetEvaluation: [],
      rowTotal: [],
      dataLoaded: false,
      uuid: "consolidated",
      dataUuid: [],
      unit: "default",
      dataUnit: [],
      upul: "default",
      dataUpul: [{ label: "Select UP/UL", value: "default" }],
      isUpUl: true,
      isAsset: false,
      isOld: false,
      isBroke: false,
      sortKey: "name", // Default sort key
      sortAsc: true, // Default sort direction
    };
  },
  mounted() {
    this.getDataDistributionAssetEvaluation("");
    this.getRefUid();
    this.getRefUnit();
    // this.getRefUpUl();
  },
  watch: {
    uuid() {
      if (this.uuid !== "") {
        const filter = this.dataUuid.filter((item) => item.value == this.uuid);
        this.uidTool = filter[0].label;
        this.upUlTool = "";
        this.upul = "default";
        this.getRefUpUl(this.uuid);
        this.getDataDistributionAssetEvaluation(this.uuid, "", this.unit);
      } else {
        this.uidTool = "All UID";
        this.upUlTool = "";
        this.upul = "default";
        this.getDataDistributionAssetEvaluation(this.uuid, "", this.unit);
        this.isUpUl = true;
      }
    },
    upul() {
      if (this.uuid !== "") {
        const filter = this.dataUpul.filter((item) => item.value == this.upul);
        this.upUlTool = filter[0].label;
        this.getDataDistributionAssetEvaluation(
          this.uuid,
          this.upul,
          this.unit
        );
      } else {
        this.upUlTool = "";
        this.upul = "default";
      }
    },
    unit() {
      if (this.unit !== "default") {
        // const filter = this.dataUnit.filter((item) => item.value == this.upul);
        // this.upUlTool = filter[0].label;
        this.getDataDistributionAssetEvaluation(
          this.uuid,
          this.upul,
          this.unit
        );
      } else {
        this.getDataDistributionAssetEvaluation(this.uuid, this.upul, "");
        // this.upUlTool = "";
        // this.upul = "default";
        // this.unit = "default";
      }
    },
  },
  computed: {
    assetEvaluation() {
      return this.assetEvaluation.slice().sort((a, b) => {
        if (a[this.sortKey] < b[this.sortKey]) return this.sortAsc ? -1 : 1;
        if (a[this.sortKey] > b[this.sortKey]) return this.sortAsc ? 1 : -1;
        return 0;
      });
    },
  },
  methods: {
    sort(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
      if (key === "name") {
        this.isAsset = !this.isAsset;
      } else if (key === "old") {
        this.isOld = !this.isOld;
      } else {
        this.isBroke = !this.isBroke;
      }
    },
    showTooltipUpUl() {
      this.visibleUpUl = true;
    },
    hideTooltipUpUl() {
      this.visibleUpUl = false;
    },
    showTooltip() {
      this.visible = true;
      if (this.uuid === "consolidated") {
        this.uidTool = "All UID";
      }
    },
    hideTooltip() {
      this.visible = false;
    },
    async getRefUnit() {
      const res = await getRef.getRefMaterial();
      const data = res.data.data;
      const defaults = { label: "Type of Asset", value: "default" };
      const filter = data.map((project) => ({
        value: project.value,
        label: project.description,
      }));
      this.dataUnit = data;
      this.dataUnit.push(defaults);
    },
    async getRefUpUl(value) {
      const param = {
        uid: value,
      };
      const res = await getRef.getRefUpUl(param);
      const data = res.data.data;
      const defaults = { label: "Select UP/UL", value: "default" };
      this.dataUpul = data;
      this.isUpUl = false;
      this.dataUpul.push(defaults);
    },
    async getRefUid() {
      const res = await getRef.getRefUid();
      const data = res.data.data;
      const defaults = {
        label: "All UID",
        value: "consolidated",
      };
      this.dataUuid = data;
      this.dataUuid.push(defaults);
    },
    convertToMMMYYYY(month, year) {
      if (month !== null) {
        return moment(`${month}, ${year}`, "M, YYYY").format("MMM, YYYY");
      } else {
        return "-";
      }
    },
    async getDataDistributionAssetEvaluation(instance, upul, unit) {
      let param = Object.assign({
        uid: instance === "" ? "consolidated" : instance,
        // upul: upul,
        unit: unit === "default" ? "" : unit,
      });
      let paramUid = Object.assign({
        uid: instance === "" ? "consolidated" : instance,
        unit: unit === "default" ? "" : unit,
      });
      const res = await apiDistribution.getDataDistributionAssetEvaluation(
        upul !== "" ? param : paramUid
      );
      if (res && res.status == 200) {
        this.last_update = res.data.lastUpdate;
        this.periode = this.convertToMMMYYYY(
          res.data.data[0].month,
          res.data.data[0].year
        );
        const item = res.data.data.filter((item) => item.name !== "Total");
        const total = res.data.data.filter((item) => item.name === "Total");
        this.assetEvaluation = item;
        this.dataLoaded = true;
        this.rowTotal = total[0];
      }
    },
    formattedNumber,
  },
};
</script>

<style scoped>
.rowTotal {
  --bs-table-bg: #f0f0f0;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  letter-spacing: 0.02em;
}

.hidden {
  display: none;
}
.custom-dropdown {
  border-radius: 0.6rem !important;
  background-color: #e6e6e6 !important;
}
.custom-dropdown:hover {
  border: 1px solid #00a3e9 !important;
}
</style>
